import { AfterViewInit, Component, OnInit, ViewChild } from "@angular/core";
import { MatPaginator } from "@angular/material/paginator";
import { MatSort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";
import { ActivatedRoute } from "@angular/router";
import { faDownload, faSpinner } from "@fortawesome/free-solid-svg-icons";
import LocalizationConstants from "src/app/constants/localization-constants";
import { ContractDocument } from "src/app/models/ContractDocument";
import { CompanyService } from "src/app/services/company.service";

import { ContractService } from "./../../services/contract.service";
import { FileService } from "./../../services/file.service";

@Component({
  selector: "app-contract-documents",
  templateUrl: "./contract-documents.component.html",
  styleUrls: ["./contract-documents.component.scss"],
  standalone: false,
})
export class ContractDocumentsComponent implements OnInit, AfterViewInit {
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  dataSource = new MatTableDataSource<ContractDocument>([]);
  isLoading: boolean;
  faSpinner = faSpinner;
  faDownload = faDownload;
  contractRef: string;
  pageSize: number = 10;
  localizationConstants = LocalizationConstants;

  constructor(
    public contractService: ContractService,
    private companyService: CompanyService,
    private route: ActivatedRoute,
    private fileService: FileService,
  ) {}

  ngOnInit() {
    this.contractRef = this.route.parent.snapshot.paramMap.get("contractReference");
    if (!this.companyService.selectedCompany?.name) return;
    this.getContractDocuments();
  }

  ngAfterViewInit() {
    this.dataSource.sort = this.sort;
    this.dataSource.paginator = this.paginator;
  }

  getContractDocuments() {
    this.isLoading = true;
    this.contractService
      .getContractDocuments(this.companyService.selectedCompany.name, this.contractRef)
      .subscribe(
        (response) => {
          this.isLoading = false;
          if (!response) return;
          this.dataSource.data = response;
        },
        () => (this.isLoading = false),
      );
  }

  async download(document: ContractDocument) {
    const data = await this.contractService.getContractDocument(document).toPromise();
    this.fileService.downloadFile(data, document.fileName);
  }
}
